/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Op_InInputs */

const cs_op_in = /** @type {(inputs: Op_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`v`)
};

const en_op_in = /** @type {(inputs: Op_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`in`)
};

/**
* | output |
* | --- |
* | "in" |
*
* @param {Op_InInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const op_in = /** @type {((inputs?: Op_InInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Op_InInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_op_in(inputs)
	return cs_op_in(inputs)
});